import { Button, Drawer, Form, Input, Space } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { IBaseDrawerModel } from "../../../Types";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import OrganisationsService, {
  IOrganiseData,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";

const AddOrganisationModel = ({
  isModalOpen,
  setIsModalOpen,
  id,
  setTrigger,
}: IBaseDrawerModel) => {
  const [form] = Form.useForm<IOrganiseData>();
  const { currentClient } = useClient();
  const { openNotification } = useContext(notificationContext);
  const [loading, setLoading] = useState<boolean>(false);

  const saveData = async (formData: IOrganiseData) => {
    setLoading(true);
    await OrganisationsService.postOrganisation(
      currentClient?.id!,
      formData,
      id!
    )
      .then((val: IApiResponse<IIdNameModel>) => {
        openNotification(
          "success",
          `${val?.result?.name} organisation ${
            id ? "updated" : "added"
          } successfully`
        );
        setIsModalOpen({
          open: false,
          id: "",
        });
        setLoading(false);
        setTrigger && setTrigger((prev) => !prev);
      })
      .catch((er) => {
        openNotification("error", er.message);
        setLoading(false);
      });
  };

  const submitForm = (val: IOrganiseData) => {
    saveData(val);
  };

  const getData = async () => {
    setLoading(true);
    await OrganisationsService.getOrganisation(currentClient?.id!, id!)
      .then((val: IOrganiseData | null) => {
        form.setFieldValue("orgName", val?.orgName);
        setLoading(false);
      })
      .catch((er) => {
        openNotification("error", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <Drawer
      open={isModalOpen}
      onClose={() =>
        setIsModalOpen({
          open: false,
          id: "",
        })
      }
      title={`${id ? "Update" : "Save"} organisation`}
      width={"30vw"}
      extra={
        <Space>
          <Button
            disabled={loading}
            onClick={() => {
              form.resetFields();
              setIsModalOpen({
                open: false,
                id: "",
              });
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            loading={loading}
            type="primary"
            onClick={() => {
              form.validateFields().then(submitForm);
            }}
          >
            {`${id ? "Update" : "Save"}`}
          </Button>
        </Space>
      }
    >
      <Form
        name="organisation"
        form={form}
        disabled={loading}
        layout="vertical"
      >
        <Form.Item
          name="orgName"
          label="Organisation's Name"
          rules={[
            { required: true },
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]{2,49}$/,
              message: "Value's length must be between 3 and 50",
            },
          ]}
        >
          <Input
            type="text"
            maxLength={50}
            minLength={3}
            placeholder="Enter name here..."
          ></Input>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddOrganisationModel;
